const StatsAsBarChartStyle = {
  margin: {
    top: 50,
    right: 180,
    bottom: 50,
    left: 60,
  },
  axisLeft: {
    orient: 'left',
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legendPosition: 'middle',
    legendOffset: -50,
  },
  padding: 0.3,
  axisBottom: {
    orient: 'bottom',
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: 'Année',
    legendPosition: 'middle',
    legendOffset: 36,
  },
  labelSkipWidth: 12,
  labelSkipHeight: 12,
  animate: true,
  motionStiffness: 90,
  motionDamping: 15,
  legends: [
    {
      dataFrom: 'keys',
      anchor: 'bottom-right',
      direction: 'column',
      translateX: 110,
      translateY: 0,
      itemsSpacing: 2,
      itemWidth: 100,
      itemHeight: 20,
      itemOpacity: 0.85,
      symbolSize: 15,
      effects: [
        {
          on: 'hover',
          style: {
            itemOpacity: 1,
          },
        },
      ],
    },
  ],
};

export default StatsAsBarChartStyle;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatsAsBarChartStyle.js